import LTR from "@brand-icons/global/social-facebook/social-facebook-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialFacebookIcon = iconFactory("SocialFacebookIcon", LTR);
